import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'c-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
  })
  export class FooterComponent implements OnInit {

  ngOnInit(): void {
    // console.log("init");
  }
 
      
  }